import React from 'react';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import { containerSx } from './Loading.styles';

export interface LoadingIndicator {
  color?: string;
}

export const LoadingIndicator: React.FC<LoadingIndicator> = ({
  color = '#7acc79',
}) => {
  return (
    <Box sx={containerSx}>
      <CircularProgress sx={{ color }} />
    </Box>
  );
};
